module.exports = __webpack_public_path__ + "img/google-play.2b65293b.png";